import styled, { css } from 'styled-components';

var Icon = styled.svg.withConfig({
  displayName: "style__Icon",
  componentId: "sc-mzs1u1-0"
})(["display:inline-block;height:22px;width:22px;", " ", " ", " ", " ", " ", " ", ""], function (props) {
  return props.size === 'xxxs' && css(["height:10px;width:10px;"]);
}, function (props) {
  return props.size === 'xxs' && css(["height:12px;width:12px;"]);
}, function (props) {
  return (props.size === 'xs' || props.size === 'x-small') && css(["height:16px;width:16px;"]);
}, function (props) {
  return props.size === 's' && css(["height:22px;width:22px;"]);
}, function (props) {
  return (props.size === 'm' || props.size === 'medium') && css(["height:32px;width:32px;"]);
}, function (props) {
  return (props.size === 'l' || props.size === 'large') && css(["height:48px;width:48px;"]);
}, function (props) {
  return (props.size === 'xl' || props.size === 'x-large') && css(["height:64px;width:64px;"]);
});

export { Icon };
//# sourceMappingURL=style.js.map
